<template>
  <VueMarkdownEditor
    :model-value="markdown"
    :height="height"
    :placeholder="placeholder"
    :right-toolbar="rightToolbar"
    :left-toolbar="leftToolbar"
    :mode="mode"
    @change="handleBeforePreviewChange"
  />
  <div v-if="isError" class="markdown-warning">
    Warning! The code editor only supports the following tags {{ allowedTags }}
  </div>
</template>

<script>
import VueMarkdownEditor from '@kangc/v-md-editor'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import enUS from '@kangc/v-md-editor/lib/lang/en-US'
import Prism from 'prismjs'

VueMarkdownEditor.use(vuepressTheme, {
  Prism
})
VueMarkdownEditor.lang.use('en-US', enUS)
export default {
  name: 'MarkdownEditorField',
  components: {
    VueMarkdownEditor
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '400px'
    },
    placeholder: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'edit' // edit | editable | preview
    },
    rightToolbar: {
      type: String,
      default: '' // preview toc sync-scroll fullscreen
    },
    leftToolbar: {
      type: String,
      default: 'undo redo clear bold link ul ol' // undo redo clear | h bold italic strikethrough quote | ul ol table hr | link image code | save
    },
    allowedTags: {
      type: Array,
      default: () => ['p', 'br', 'em', 'strong', 'a', 'ol', 'ul', 'li']
    },
    allowedAttrs: {
      type: Array,
      default: () => ['href', 'target']
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      markdown: this.modelValue,
      isError: false
    }
  },
  methods: {
    handleBeforePreviewChange(value) {
      const items = this.sanitizeContent(value)
      const domParser = new DOMParser()
      const doc = domParser.parseFromString(items, 'text/html')
      const links = doc.querySelectorAll('a')
      links.forEach((link) => {
        link.setAttribute('target', '_blank')
        Array.from(link.attributes).forEach((item) => {
          if (!this.$props.allowedAttrs.includes(item.name)) {
            link.removeAttribute(item.name)
          }
        })
      })
      const html = doc.body.innerHTML
      this.$emit('update:modelValue', html)
    },
    sanitizeContent(value) {
      this.isError = false
      const el = document.createElement('div')
      el.innerHTML = value
      const nodes = el.querySelectorAll('*')

      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i]

        if (!this.$props.allowedTags.includes(node.tagName.toLowerCase())) {
          this.isError = true
          node.parentNode.removeChild(node)
        }
      }
      return el.innerHTML
    }
  }
}
</script>

<style lang="scss" scoped>
.markdown-warning {
  padding: 10px;
  background: #ffc107;
  border-radius: 5px;
  margin-top: 10px;
}
</style>
